package org.tlsys.jobs.api

import org.tlsys.AutoLoadAsyncListIterator
import org.tlsys.json.jdto

fun JobAdminService.executionsIterator(minFull: Int, max: Int) =
    AutoLoadAsyncListIterator(minFull = minFull, max = max) { max, offset ->
        getExecutions(offset = offset.jdto, max = max.jdto).promise
    }
